<template>
  <div class="company-user-item-device-bd">
    <div class="tip-box ub ub-xc" v-if="tip">
      <div style="padding: 2px 12px 0 16px">
        <i class="icon icon-tishi"></i>
      </div>
      <div class="tip ub-f1">
        {{ $t('cui_device_jrzzbmxmhmrglqsysbkzsdfpzfpqtsb') }}
      </div>
      <div style="padding: 0 20px" @click="tip = false">
        <i class="icon icon-guanbi"></i>
      </div>
    </div>
    <div class="ub" style="padding: 24px 24px 0; height: 520px">
      <div class="ub-f2 ubv">
        <user-device-location style="height: 100%" :noAuth="true" :userId="userId" @success="loadDevices()"></user-device-location>
      </div>
      <div style="margin: 0 24px 32px; width: 1px; background: #f5f5f5"></div>
      <div class="ub-f3 ubv">
        <div class="tab-box">
          <el-tabs v-model="active">
            <el-tab-pane :label="$t('cui_device_xiang_mu')" name="location"></el-tab-pane>
            <el-tab-pane :label="$t('cui_device_ji_qi')" name="device"></el-tab-pane>
          </el-tabs>
        </div>
        <bind-location-info ref="location" v-if="active === 'location'" :userId="userId"></bind-location-info>
        <bind-device-item ref="device" v-if="active === 'device'" :permission="{ add: true, del: true }" :user="{ bizId: userId, bizType: 3 }"></bind-device-item>
      </div>
    </div>
    <div class="footer ub ub-xc ub-ae">
      <el-button @click="onCancel">{{ $t('com_cancel') }}</el-button>
      <el-button type="warning" v-if="type === 'add'" @click="onBack()">{{ $t('com_last_step') }}</el-button>
      <el-button type="warning" v-if="type === 'add'" @click="onStep()">{{ $t('cui_device_xia_yi_bu') }}</el-button>
      <el-button type="warning" v-if="type == 'edit'" @click="onCancel()">{{ $t('com_save') }}</el-button>
    </div>
  </div>
</template>

<script>
import bindDeviceItem from '../../distribution/children/bind_device_item.vue';
import bindLocationInfo from '../../distribution/children/bind_location_info.vue';
import userDeviceLocation from '../../distribution/children/user_device_location.vue';

// cui_device_jrzzbmxmhmrglqsysbkzsdfpzfpqtsb: 加入组织/部门/项目后，默认关联其所有设备，可在 手动分配 中分配其他设备// cui_device_xia_yi_bu: 下一步// cui_device_xiang_mu: 项目// cui_device_ji_qi: 机器

export default {
  name: 'company_user_item_device',
  props: {
    type: String,
    userId: [String, Number],
  },
  components: { userDeviceLocation, bindDeviceItem, bindLocationInfo },
  data() {
    return {
      tip: true,
      active: 'location',
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  mounted: function () {
    this.mergeLanguage(null, 'portal_company_user_item_device');},
  methods: {
    loadDevices() {
      this.$nextTick(() => {
        if (this.$refs.location) {
          this.$refs.location.onPageChange({ page: 1 });
        }
        if (this.$refs.device) {
          this.$refs.device.onPageChange({ page: 1 });
        }
      });
    },
    onCancel: function () {
      this.$emit('cancel');
    },
    onBack: function () {
      this.$emit('back');
    },
    onStep: function () {
      this.$emit('step', { name: 'device' });
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.company-user-item-device-bd {
  .custom-pagination {
    padding: 12px 0;
  }
  .tip-box {
    height: 52px;
    background: rgba(0, 160, 217, 0.08);
    .icon {
      font-size: 18px;
      cursor: pointer;
      color: $--color-primary;
    }
    .tip {
      color: $--color-text-secondary;
      font-size: 14px;
    }
  }
  .side li {
    height: 48px;
    cursor: pointer;
    padding: 0 12px;
    .name {
      color: $--color-text-regular;
      font-size: 14px;
    }
    &.cur {
      border: 1px solid $--color-primary;
      border-radius: 8px;
      box-sizing: border-box;
      background: #f8f9fa;
      .name {
        color: $--color-primary;
        font-size: 14px;
        font-weight: bold;
      }
    }
    &.auto .el-input__inner {
      background: rgba(179, 179, 179, 0.16);
    }
    .el-input--suffix .el-input__inner {
      padding-right: 24px;
      padding: 0 10px;
      border-radius: 28px;
      line-height: 24px;
    }
    i.el-select__caret {
      font-family: 'icon' !important;
      font-size: 16px;
      width: 20px;
      color: $--color-text-primary;
      &:before {
        content: '\e7f8';
      }
      &:after {
        content: '';
        display: none;
      }
    }
  }
  .footer {
    height: 88px;
    padding: 0 24px;
    background: #f8f9fa;
  }
}
</style>
